module.exports = __webpack_public_path__ + "img/VP-Standard_Overview-Front_4.006c6d40.jpg";